// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","PanelFooter":"bee_a bhu_b bhu_tu bhu_qz bhu_ra bhu_uo","PanelFooter--link":"bee_b"};